import { useEffect } from "react";

/**
 * Presents the user with a dialog to confirm that they want to navigate away from the page.
 */
export const useConfirmPageClose = () => {
  useEffect(() => {
    const tabCloseConfirmation = (e: BeforeUnloadEvent) => {
      e.returnValue = 'You haven\'t submitted your assessment, are you sure you want to exit?\nYou\'ll need to revisit this page using the link we\'ve sent you.';
      e.preventDefault();
    }

    window.addEventListener("beforeunload", tabCloseConfirmation);

    return () => window.removeEventListener("beforeunload", tabCloseConfirmation);
  }, []);
}
